import { render, staticRenderFns } from "./AuthAdminInvitePhysicians.vue?vue&type=template&id=3ffe8602&scoped=true"
import script from "./AuthAdminInvitePhysicians.vue?vue&type=script&lang=js"
export * from "./AuthAdminInvitePhysicians.vue?vue&type=script&lang=js"
import style0 from "./AuthAdminInvitePhysicians.vue?vue&type=style&index=0&id=3ffe8602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe8602",
  null
  
)

export default component.exports